var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(241, 242, 243, 0)",
      display: "block"
    },
    width: "72px",
    height: "72px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 50,
    fill: "rgba(69, 72, 51, 0.3070967741935484)",
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5999999999999996;3.5999999999999996;6;3.5999999999999996;3.5999999999999996",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    repeatCount: "indefinite",
    begin: "-0.925925925925926s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484);#454833;rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484)",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    begin: "-0.925925925925926s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.31088913245536,
    cy: 67.5,
    fill: "rgba(69, 72, 51, 0.3070967741935484)",
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5999999999999996;3.5999999999999996;6;3.5999999999999996;3.5999999999999996",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    repeatCount: "indefinite",
    begin: "-0.8417508417508418s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484);#454833;rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484)",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    begin: "-0.8417508417508418s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 80.31088913245534,
    fill: "rgba(69, 72, 51, 0.3070967741935484)",
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5999999999999996;3.5999999999999996;6;3.5999999999999996;3.5999999999999996",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    repeatCount: "indefinite",
    begin: "-0.7575757575757577s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484);#454833;rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484)",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    begin: "-0.7575757575757577s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 85,
    fill: "rgba(69, 72, 51, 0.3070967741935484)",
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5999999999999996;3.5999999999999996;6;3.5999999999999996;3.5999999999999996",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    repeatCount: "indefinite",
    begin: "-0.6734006734006734s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484);#454833;rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484)",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    begin: "-0.6734006734006734s"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.50000000000001,
    cy: 80.31088913245536,
    fill: "rgba(69, 72, 51, 0.3070967741935484)",
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5999999999999996;3.5999999999999996;6;3.5999999999999996;3.5999999999999996",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    repeatCount: "indefinite",
    begin: "-0.5892255892255893s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484);#454833;rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484)",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    begin: "-0.5892255892255893s"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.689110867544645,
    cy: 67.5,
    fill: "rgba(69, 72, 51, 0.3070967741935484)",
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5999999999999996;3.5999999999999996;6;3.5999999999999996;3.5999999999999996",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    repeatCount: "indefinite",
    begin: "-0.5050505050505051s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484);#454833;rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484)",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    begin: "-0.5050505050505051s"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 50.00000000000001,
    fill: "rgba(69, 72, 51, 0.3070967741935484)",
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5999999999999996;3.5999999999999996;6;3.5999999999999996;3.5999999999999996",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    repeatCount: "indefinite",
    begin: "-0.4208754208754209s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484);#454833;rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484)",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    begin: "-0.4208754208754209s"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.689110867544642,
    cy: 32.500000000000014,
    fill: "rgba(69, 72, 51, 0.3070967741935484)",
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5999999999999996;3.5999999999999996;6;3.5999999999999996;3.5999999999999996",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    repeatCount: "indefinite",
    begin: "-0.3367003367003367s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484);#454833;rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484)",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    begin: "-0.3367003367003367s"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.499999999999986,
    cy: 19.689110867544656,
    fill: "rgba(69, 72, 51, 0.3070967741935484)",
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5999999999999996;3.5999999999999996;6;3.5999999999999996;3.5999999999999996",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    repeatCount: "indefinite",
    begin: "-0.25252525252525254s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484);#454833;rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484)",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    begin: "-0.25252525252525254s"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.99999999999999,
    cy: 15,
    fill: "rgba(69, 72, 51, 0.3070967741935484)",
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5999999999999996;3.5999999999999996;6;3.5999999999999996;3.5999999999999996",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    repeatCount: "indefinite",
    begin: "-0.16835016835016836s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484);#454833;rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484)",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    begin: "-0.16835016835016836s"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 19.68911086754465,
    fill: "rgba(69, 72, 51, 0.3070967741935484)",
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5999999999999996;3.5999999999999996;6;3.5999999999999996;3.5999999999999996",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    repeatCount: "indefinite",
    begin: "-0.08417508417508418s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484);#454833;rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484)",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    begin: "-0.08417508417508418s"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.31088913245534,
    cy: 32.499999999999986,
    fill: "rgba(69, 72, 51, 0.3070967741935484)",
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3.5999999999999996;3.5999999999999996;6;3.5999999999999996;3.5999999999999996",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    repeatCount: "indefinite",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484);#454833;rgba(69, 72, 51, 0.3070967741935484);rgba(69, 72, 51, 0.3070967741935484)",
    repeatCount: "indefinite",
    times: "0;0.1;0.2;0.3;1",
    dur: "1.0101010101010102s",
    begin: "0s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.2a443bd05eb018d4644b228def65ee8b.svg";
export { ForwardRef as ReactComponent };